export default "__VITE_ASSET__CwVUS3nm__"